export interface CartAnimationEvent {
    target: EventTarget | null;
}

export interface CartAnimationConfig {
    productCardSelector: string;
    productImageSelector: string;
    miniCartSelector: string;
    duration: number;
    startScale: number;
    midScale: number;
    endScale: number;
    arcHeight: number;
    rotateDeg: number;
    cloneSize: number;
}

export const MINI_CART_BUTTON_SELECTOR = '[data-mini-cart-button]';

export const DEFAULT_CART_ANIMATION_CONFIG: CartAnimationConfig = {
    productCardSelector: '.product-card',
    productImageSelector: '.product-image',
    miniCartSelector: MINI_CART_BUTTON_SELECTOR,
    duration: 550,
    startScale: 1,
    midScale: 0.9,
    endScale: 0.22,
    arcHeight: 100,
    rotateDeg: 0.8,
    cloneSize: 88,
};

export const CART_CLONE_BASE_STYLES = {
    position: 'fixed',
    left: '0',
    top: '0',
    margin: '0',
    padding: '0',
    zIndex: '99999',
    pointerEvents: 'none',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 12px 28px rgba(0,0,0,0.14)',
    backfaceVisibility: 'hidden',
    willChange: 'transform, opacity',
    transformOrigin: 'center center',
    contain: 'layout paint style',
    opacity: '1',
} as const;
